"use client";

import { PropsWithChildren } from "react";
import { ProvidersFilterByLabel } from "./components/providers-filter-by-label";
import { ProvidersSearch } from "./components/providers-search";
import { FilerContextProvider } from "./filter-context";
import { ProvidersCategories } from "./components/providers-categories";
import { PageSubtitle, PageTitle } from "@/shared/ui";
export default function ProvidersLayout({
  children
}: PropsWithChildren) {
  return <FilerContextProvider data-sentry-element="FilerContextProvider" data-sentry-component="ProvidersLayout" data-sentry-source-file="layout.tsx">
      <div className="flex flex-col gap-6">
        <header>
          <PageTitle data-sentry-element="PageTitle" data-sentry-source-file="layout.tsx">Providers</PageTitle>
          <PageSubtitle data-sentry-element="PageSubtitle" data-sentry-source-file="layout.tsx">
            Connect monitoring services for Keep to ingest alerts, and other
            integrations to automate your workflows.
          </PageSubtitle>
        </header>
        <main>
          <div className="flex w-full flex-col items-center mb-4">
            <div className="flex w-full">
              <ProvidersSearch data-sentry-element="ProvidersSearch" data-sentry-source-file="layout.tsx" />
              <ProvidersFilterByLabel data-sentry-element="ProvidersFilterByLabel" data-sentry-source-file="layout.tsx" />
            </div>
            <ProvidersCategories data-sentry-element="ProvidersCategories" data-sentry-source-file="layout.tsx" />
          </div>
          <div className="flex flex-col">{children}</div>
        </main>
      </div>
    </FilerContextProvider>;
}